import { MEDIA_TYPE } from "../../features/base/tracks/constants";
import { getLocalMainKinoTrack } from "../../features/base/tracks/functions";
import { disableScreenshareView, enableScreenshareView } from "../../features/screen-share/ScreenshareUI";
import { CONV_STORAGE, room, Video, volumeManager, cameraOptionsPreferences, spacesView, kinoParticipants, screenShare, isCameraMuted , muteAll, isMicMuted} from "../../libs/roomnew";

export default class Participant{
    constructor(id,name='',local=false){
        this.id=id;
        this.name=name;
        this.local=local;
        this.spaceThumbnail=null;
        this.lobbyThumbnail=null;
        this.space_id=null;
        this.role="none";
        this.email="";
        this.micMutedIcon = `<svg width="15px" height="15px" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M265.403 88.2228C264.31 53.2236 235.217 25.0055 199.999 25.0055C163.906 25.0055 134.375 54.536 134.375 90.6289V200.001C134.375 205.907 135.25 211.376 136.781 216.845L265.403 88.2228Z" fill="#FF3D00"/>
        <path d="M199.999 265.625C236.092 265.625 265.622 236.094 265.622 200.001V149.843L371.801 43.6644C376.066 39.3989 376.066 32.4647 371.801 28.1991C367.535 23.9336 360.601 23.9336 356.336 28.1991L28.2183 356.316C23.9309 360.582 23.9309 367.516 28.1964 371.782C32.4619 376.069 39.3743 376.069 43.6617 371.804L131.335 284.131C147.565 297.19 167.253 306.049 189.061 308.28V364.06C189.061 370.185 193.874 374.997 199.999 374.997C206.123 374.997 210.936 370.185 210.936 364.06V308.28C266.06 302.593 309.371 256.656 309.371 200.001V189.064C309.371 182.939 304.559 178.127 298.434 178.127C292.309 178.127 287.497 182.939 287.497 189.064V200.001C287.497 248.344 248.341 287.499 199.999 287.499C179.874 287.499 161.5 280.324 146.603 268.862L162.112 253.353C172.852 260.987 185.977 265.625 199.999 265.625V265.625Z" fill="#FF3D00"/>
        <path d="M119.501 234.126C114.907 223.626 112.501 212.032 112.501 200.001V189.064C112.501 182.939 107.688 178.127 101.563 178.127C95.4386 178.127 90.6262 182.939 90.6262 189.064V200.001C90.6262 218.376 95.2199 235.438 103.095 250.531L119.501 234.126Z" fill="#FF3D00"/>
        </svg>`;
        this.cameraMutedIcon = `<svg width="15px" height="15px" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M46.4372 307.202L262.121 91.5075C259.715 90.8513 257.309 90.6325 254.684 90.6325H57.812C39.656 90.6325 25 105.289 25 123.446V276.576C25 290.795 33.9686 302.827 46.4372 307.202Z" fill="#FF3D00"></path><path d="M359.245 113.602L287.496 149.478V127.974L371.801 43.6654C376.066 39.3997 376.066 32.4651 371.801 28.1993C367.535 23.9336 360.601 23.9336 356.335 28.1993L28.2156 356.335C23.95 360.6 23.95 367.535 28.2156 371.801C32.4811 376.066 39.4154 376.066 43.6809 371.801L106.089 309.389H254.684C272.84 309.389 287.496 294.733 287.496 276.576V250.544L359.245 286.42C363.292 288.148 367.032 287.689 369.745 285.982C373.026 283.795 374.995 280.295 374.995 276.576V123.446C374.995 119.727 373.026 116.227 369.745 114.04C366.682 112.071 362.526 111.852 359.245 113.602V113.602Z" fill="#FF3D00"></path></svg>`
        this.menuNoCameraLayerThumb=null
        this.menuPrivateSpace=null
        this.screenShareMode=false;
    };

    setRole(role){
        this.role=role;
    };
    isHostOrModerator(){
        return this.role=="moderator" || this.role=="host";
    };
    setName(name){
        this.name=name;
    };

    setEmail(email){
        this.email=email
    }

    getSpaceId(){
        return this.space_id;
    };
    //check if this participant is in my lobby
    inMyLobby(){
        if(CONV_STORAGE.myConversation && this.space_id == CONV_STORAGE.myConversation){
            return true;
        }else if(this.space_id){
            return false;
        }else if(!CONV_STORAGE.myConversation && !this.space_id){
            if(Video.focused[this.id]){
                return true
            }else if(Object.keys(Video.focused).length == 0){
                return true;
            }else{
                return false;
            }
        }else{
            return false;
        }
    };

    inSameSpaceWithMe(){
        if(this.local){return true}
        if(CONV_STORAGE.myConversation && this.space_id == CONV_STORAGE.myConversation){
            return true;
        }else if(!CONV_STORAGE.myConversation && !this.space_id){
            return true;
        }
        return false;
    }


setVolume(volume, slider = true, skipAnnouncer=false,allowVolumeLock=false) {
    if(!Video.videos[this.id] || this.local){
        return;
    }
    if(volume > 0){
        volumeManager.lastParticipantVolume[this.id]=volume;
        Video.videos[this.id].isMuted=false;
    }else{
        Video.videos[this.id].isMuted=true;
    }
    console.trace(`Setting volume ${volume} for `+this.getName());
    if(!skipAnnouncer){
        if(Video.announcement.updateOriginalVolume(this.id,volume,allowVolumeLock)){
            console.warn(`Announcer is speaking change volume is disabled`);
            return;
        }
    }
    volumeManager.updateParticipantTileVolume(volume, this.id);
    console.log("Checking if master volume is locked",Video.lockMasterVolume.isLocked());
    console.log(`Changing volume property`,Video.videos[this.id].audioPlayer)
    Video.videos[this.id].volume = volume;
    try {
        if(Video.videos[this.id].audioPlayer && Video.videos[this.id].audioPlayer.srcObject){
            Video.videos[this.id].audioPlayer.volume=volume;
        }
        if(Video.videos[this.id].player){
            Video.videos[this.id].player.volume=volume;
        }
        console.trace("change audio file volume property to :" + volume);
    } catch (error) {
        console.error("setVolume for participant error",error);
    }


    if (slider && Video.videos[this.id].audios.slider) {
        Video.videos[this.id].audios.slider.val(volume);
    }
    try {
        let formated=Math.round(volume * 100).toFixed(0);
        Video.videos[this.id].viewContainer.find(".audioVal").html(formated+"%");
    } catch (e) {
        console.log("Error updating volume percentage...");
    }
};
        //end card 584

    remove(){
        // console.error("Participant left Kino removing space",this.space_id);
        return new Promise((resolve,reject)=>{
            if(this.space_id){
                CONV_STORAGE.getSpace(this.space_id).participantLeft(this.id);
            }else{
                spacesView.renderLobbySpaceTiles();
            }
            screenShare.popup.onUserLeft(this.id);
            resolve();
        });
    };

    moveToSide(){
        if(this.local){
            Video.localVideoMinimize();
        }else{
            if(!Video.sideParticipants[this.id]){
                Video.moveVideoToSide(this.id);
            }
        }

    };

    moveToMain(){
        if(this.local){
            Video.localVideoMaximize();
        }else{
            if(!Video.mainParticipants[this.id]){
                Video.moveVideoToMain(this.id);
            }else{
                console.log("already in main videos")
            }
        }
    };

    addOnSpace(space_id){
        try {
            this.space_id=space_id;
            // this.createSpaceThumbnail(space_id);
            // let participantsCount=CONV_STORAGE.conversations[space_id].participants.length;
            CONV_STORAGE.changeConversationOrder(space_id);
        } catch (error) {
            console.error("Add on space error",error);
        }
    };
    getVideo(){
        try {
            let videoTrack=this.local ? getLocalMainKinoTrack() : Video.getParticipantVideo(this.id);
            if(videoTrack){
                return videoTrack;
            }else{
                return false;
            }
        } catch (error) {
            return false
        }
    };
    getName(){
        try {
            if(this.local){return MY_NAME;}
            let p=room.getParticipantById(this.id);
            if(p){
                return p.getDisplayName();
            }else{
                return "Kino User";
            }
        } catch (error) {
            return "Kino User"
        }
    };

    setAsFocused(){
        try {
            $("#wave-"+this.id).remove();
            Video.videos[this.id].focusButton.html(Video.focusedIcon);
            Video.videos[this.id].viewContainer.addClass('focused-me');
            Video.videos[this.id].focusButton.addClass('active');
            // Video.videos[this.id].focusButton.attr('title', 'Unfocus');
            // Video.videos[this.id].focusButton.attr('data-original-title', 'Unfocus');
        } catch (error) {

        }

    };
    setAsFocusedMe(){
        if(Video.videos[this.id]){
            $("#wave-"+this.id).remove();
            Video.videos[this.id].focusButton.html(Video.focusedIcon);
            Video.videos[this.id].viewContainer.addClass('focused-me');
            Video.videos[this.id].focusOnMe = true;
        }
    }
    setAsUnfocused(){
        try {
            Video.videos[this.id].viewContainer.removeClass('focused-me');
            Video.videos[this.id].focusButton.html(Video.focusIcon);

            Video.videos[this.id].focusButton.removeClass('active');
            // Video.videos[this.id].focusButton.attr('title', 'Focus');
            // Video.videos[this.id].focusButton.attr('data-original-title', 'Focus');
        } catch (error) {

        }
    };

    createSpaceThumbnail(space_id){
        console.log(`Function: createSpaceThumbnail(participant:${this.id},space_id:${space_id})`);

        // if(Video.isLobbyView && participant.conversation_id!=c.myConversation && (participant.participant != room.myUserId() || room==null)){
        //     Video.speaker.removeSpeaker(participant.participant);
        //     Video.removeParticipantFromLobby(participant.participant);
        // }
        this.removeLobbyThumbnail();
        let videoElement=document.createElement('video');
        videoElement.autoplay=1;
        videoElement.muted=1;
        videoElement.setAttribute('pid',this.id);
        videoElement.classList.add('h-100','video-center','video-preview','conversation-video-player');
        if(this.id == room.myUserId() && cameraOptionsPreferences.camera_flip){
            videoElement.classList.add('flipVideoX');
        }
        // if (participant.participant == room.myUserId()) {
        //     c.myConversation = participant.conversation_id;
        //     c.conversations[c.myConversation].htmlElement.addClass(
        //         "my-conversation"
        //     );
        // }
        let previewVideo = this.getVideo();

        if (previewVideo) {
            videoElement.srcObject = previewVideo.stream;
            videoElement.oncanplay = function () {
                videoElement.play();
            };
        }

        let isMicMutedOnTile = this.local ? isMicMuted() :  Video.videos[this.id].hasMicMuted

        const isScreenshareActive = previewVideo && previewVideo?.videoType == MEDIA_TYPE.DESKTOP;
        console.log("isScreenshareActive",isScreenshareActive)
        let isCameraMutedOnTile = (this.local ? isCameraMuted() : Video.videos[this.id].isVideoMuted()) && !isScreenshareActive

        let micMuted = $('<div/>', {
            class: `in-video-mic-muted mic-status-${this.local ? "local" :this.id} cursor-pointer ${isMicMutedOnTile || "d-none"}`,
            title: "Unmute Mic",
            'data-toggle': 'tooltip',
            'data-placement': 'top',
            html: this.micMutedIcon
        })

        let cameraMuted = $('<div/>',{
            class: `in-video-camera-muted camera-status-${this.local ? "local" :this.id} cursor-pointer ${isCameraMutedOnTile || "d-none"}`,
            title: 'Camera off',
            'data-toggle': 'tooltip',
            'data-placement': 'top',
            html: this.cameraMutedIcon
        });

        let displayName = $('<div/>', {
            class: `participant-display-name ellipsis noselect display-name-${this.id}`,
            html: this.local ? this.getName() + " (me)" : this.getName()
        });

        let nameContainer = $("<div/>", {
            class: `participant-name ellipsis noselect display-name-${this.id}`,
            html: [displayName,micMuted,cameraMuted]
        })

        let noCameraCirce=$('<div/>',{
            class: 'no-cam-layer-background mb-2',
            html: Video.noCameraIcon
        });
        this.noCameraLayerThumb=$("<div/>",{
            class:'no-camera-spaces-thumb d-none',
            html:[noCameraCirce]
        });

        let vidcontainer = $("<div/>", {
            class: "videoContainer participant-container text-center",
            html: [nameContainer,videoElement,this.noCameraLayerThumb],
        });

        this.spaceThumbnail = $("<div/>", {
            style: `height:${spacesView.getTileHeight()}px;width:${spacesView.getTileWidth()}px;`,
            class: `participant-video-container pid_${this.id}`,
            'space-id': space_id,
            html: [vidcontainer],
        });
        let space=CONV_STORAGE.getSpace(space_id);
        space.tiles.append(this.spaceThumbnail);
        //show no camera layer if video is muted
        if(Video.videos[this.id]){
            if(Video.videos[this.id].isVideoMuted() && !isScreenshareActive){
                Video.videos[this.id].onVideoMuted();
            }
        }else if(this.id==room.myUserId() && isCameraMuted() && !isScreenshareActive){
            this.noCameraLayerThumb.removeClass('d-none');
        }

        if (space_id == CONV_STORAGE.myConversation) {
            CONV_STORAGE.updateBanner();
        }


        // CONV_STORAGE.changeConversationOrder(space_id);
    };


    createLobbyThumbnail(){
        console.trace(`Function: createLobbyThumbnail(participant:${this.id}})`);

        // if(Video.isLobbyView && participant.conversation_id!=c.myConversation && (participant.participant != room.myUserId() || room==null)){
        //     Video.speaker.removeSpeaker(participant.participant);
        //     Video.removeParticipantFromLobby(participant.participant);
        // }
        let videoElement=document.createElement('video');
        videoElement.autoplay=1;
        videoElement.muted=1;
        videoElement.setAttribute('pid',this.id);
        videoElement.classList.add('h-100','video-center','video-preview','conversation-video-player');
        if(this.id == room.myUserId() && cameraOptionsPreferences.camera_flip){
            videoElement.classList.add('flipVideoX');
        }
        // if (participant.participant == room.myUserId()) {
        //     c.myConversation = participant.conversation_id;
        //     c.conversations[c.myConversation].htmlElement.addClass(
        //         "my-conversation"
        //     );
        // }
        let previewVideo = this.getVideo();

        if (previewVideo) {
            console.log("Video preview found for ",this.getName(),previewVideo);
            videoElement.srcObject = previewVideo.stream;
            videoElement.oncanplay = function () {
                videoElement.play();
            };
        }
        let isMicMutedOnTile = this.local ? isMicMuted() :  Video.videos[this.id].hasMicMuted

        const isScreenshareActive = previewVideo && previewVideo?.videoType == MEDIA_TYPE.DESKTOP;
        console.log("isScreenshareActive",isScreenshareActive)
        let isCameraMutedOnTile = (this.local ? isCameraMuted() : Video.videos[this.id].isVideoMuted()) && !isScreenshareActive
        console.log("isCameraMutedOnTile",isCameraMutedOnTile)
        let micMuted = $('<div/>', {
            class: `in-video-mic-muted mic-status-${this.local ? "local" :this.id} cursor-pointer ${isMicMutedOnTile || "d-none"}`,
            title: "Mic muted",
            'data-toggle': 'tooltip',
            'data-placement': 'top',
            html: this.micMutedIcon
        })

        let cameraMuted = $('<div/>',{
            class: `in-video-camera-muted camera-status-${this.local ? "local" :this.id} cursor-pointer ${isCameraMutedOnTile || "d-none"}`,
            title: 'Camera off',
            'data-toggle': 'tooltip',
            'data-placement': 'top',
            html: this.cameraMutedIcon
        });

        let displayName = $('<div/>', {
            class: `participant-display-name ellipsis noselect display-name-${this.id}`,
            html: this.local ? this.getName() + " (me)" : this.getName()
        });

        let nameContainer = $("<div/>", {
            class: `participant-name ellipsis noselect display-name-${this.id}`,
            html: [displayName,micMuted,cameraMuted]
        })

        let noCameraCirce=$('<div/>',{
            class: 'no-cam-layer-background mb-2',
            html: Video.noCameraIcon
        });
        this.noCameraLayerThumb=$("<div/>",{
            class:'no-camera-spaces-thumb d-none',
            html:[noCameraCirce]
        });
        let vidcontainer = $("<div/>", {
            class: "videoContainer participant-container text-center",
            html: [nameContainer, videoElement,this.noCameraLayerThumb],
        });

        this.lobbyThumbnail = $("<div/>", {
            style: `height:${spacesView.getTileHeight()}px;width:${spacesView.getTileWidth()}px;`,
            class: `participant-video-container pid_${this.id}`,
            pid: this.id,
            html: [vidcontainer],
        });
        if(this.local){
            spacesView.lobbyTiles.prepend(this.lobbyThumbnail);
        }else{
            spacesView.lobbyTiles.append(this.lobbyThumbnail);
        }
        //show no camera layer if video is muted
        if(Video.videos[this.id]){
            if(Video.videos[this.id].isVideoMuted() && !isScreenshareActive){
                Video.videos[this.id].onVideoMuted();
            }
        }else if(this.id==room.myUserId() && isCameraMuted() && !isScreenshareActive){
            this.noCameraLayerThumb.removeClass('d-none');
        }

    };

    removeLobbyThumbnail(){
        try {
            if(this.lobbyThumbnail){
                this.lobbyThumbnail.remove();
                this.lobbyThumbnail=null;
            }
        } catch (error) {
            console.error("removeLobbyThumbnail",error)
        }
    };


    removeSpaceThumbnail(){
        try {
            if(this.spaceThumbnail){
                this.spaceThumbnail.remove();
                this.spaceThumbnail=null;
            }
            this.removeLobbyThumbnail();
        } catch (error) {
            console.error("removeSpaceThumbnail",error)
        }
    };

    removeFromSpace(space_id){
        try {
            console.log(`Remove participant ${this.getName()} from space ${space_id}, current space ${this.space_id}`)
            if(this.space_id==space_id){
                this.space_id=null;
            }
            if(CONV_STORAGE.conversations[space_id]){
                CONV_STORAGE.conversations[space_id].removeParticipant(this.id);
            }

        } catch (error) {
            console.error("Remove from space error",error);
        }
    };

    setScreenShareMode(enabled){
        try {
            if(enabled){
                enableScreenshareView(this);
                this.screenShareMode=enabled;
            }else{
                disableScreenshareView(this);
                this.screenShareMode=null;
            }
        } catch (error) {
            console.error("setScreenShareMode error",error);
        }
    }

    addSpeakerClass() {
        this.lobbyThumbnail.addClass("stage-view-speaker")
    }

    removeSpeakerClas(){
        this.lobbyThumbnail.removeClass("stage-view-speaker")
    }
};
